import React from 'react';
import classnames from 'classnames';
import { Progress } from 'antd';
import { useThemeVarsClass } from '../../../../theme/provider';
import cn from './styles.module.scss';

export type CircleProgressClassNames = {
  root?: string;
  text?: string;
  value?: string;
  label?: string;
};

export type CircleProgressProps = {
  current: number;
  total: number;
  label: string;
  color?: string;
  className?: string;
  classNames?: CircleProgressClassNames;
};

export function CircleProgress({
  current,
  total,
  label,
  color,
  className,
  classNames: classNamesProp,
}: CircleProgressProps) {
  const themeClassName = useThemeVarsClass();
  const percent = total === 0 ? 0 : 100 * (current / total);

  return (
    <div className={classnames(cn.root, themeClassName, className, classNamesProp?.root)}>
      <Progress
        type="circle"
        percent={percent}
        size={60}
        strokeColor={color}
        strokeWidth={8}
        showInfo={false}
      />
      <div className={classnames(cn.text, classNamesProp?.text)}>
        <span className={classnames(cn.value, classNamesProp?.value)}>
          {current}
          /
          {total}
        </span>
        <span className={classnames(cn.label, classNamesProp?.label)}>{label}</span>
      </div>
    </div>
  );
}
